module.exports = __webpack_public_path__ + "mainassets/img/faq-4-a.41522044.svg";